import { useAppDispatch } from 'app/hooks';
import Modal from 'components/common/modal';
import Button from 'components/inputs/button';
import Text from 'components/inputs/text';
import { fetchDefaultAdminData } from 'features/admin';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import axios from 'utils/api';
import { errorModal, successModal } from 'utils/ui';

type CreateStructureTypeModalProps = {
  openState: [boolean, Dispatch<SetStateAction<boolean>>];
};

export default function CreateStructureTypeModal({
  openState
}: CreateStructureTypeModalProps) {
  const dispatch = useAppDispatch();
  const [open, setOpen] = openState;
  const [name, setName] = useState('');

  useEffect(() => {
    setName('');
  }, [open]);

  const handleSave = async () => {
    try {
      await axios.post('structure-types', { label: name });
      successModal('Structure type created');
    } catch (error) {
      console.error(error);
      errorModal('Failed to create structure type');
    }
    dispatch(fetchDefaultAdminData());
    setOpen(false);
  };

  return (
    <Modal
      title='New Structure Type'
      openState={openState}
      size='wide'
      infoMode
    >
      <div className='flex flex-col gap-5'>
        <div className='flex flex-col gap-2'>
          <div className='font-semibold text-gray-900'>Name</div>
          <div>
            <Text
              value={name}
              onChange={(value) => setName(value)}
              placeholder='Name...'
            />
          </div>
        </div>
        <div className='flex items-center gap-3'>
          <Button text='Create' color='green' onClick={handleSave} />
          <Button text='Cancel' color='red' onClick={() => setOpen(false)} />
        </div>
      </div>
    </Modal>
  );
}
